/* eslint-disable react/prop-types */
import React from 'react'
import Grid from '@material-ui/core/Grid'
import { makeStyles } from '@material-ui/core/styles'
import PDCMarkdown from 'pdc-markdown'
import { TextField } from 'foundations-library/components'

const containerClass = 'markdown-container'

const useStyles = makeStyles(theme => ({
    searchContainer: {
        margin: 'auto'
    },
    topContainer: {
        display: 'flex',
        flexDirection: 'column',
        rowGap: '1rem'
    }
}))

const headings = ['H1', 'H2', 'H3', 'H4', 'H5', 'H6']

const hideElement = (el) => {
    el.style.display = 'none'
}

const showElement = (el) => {
    el.style.display = ''
}

function searchDetails () {
    const searchTerm = document.querySelector('input').value.toLowerCase()
    const details = document.querySelectorAll('details')

    details.forEach(detail => {
        const summary = detail.querySelector('summary').textContent.toLowerCase()
        if (summary.includes(searchTerm)) {
            showElement(detail)
        } else {
            hideElement(detail)
        }
    })

    try {
        const parentElement = document.querySelector(`.${containerClass}`)
        const directChildren = parentElement?.children
        const splitByHeading: HTMLElement[][] = []
        if (directChildren) {
            for (let i = 0; i < directChildren.length; i++) {
                let tmpArr: HTMLElement[] = []
                for (let j = 0; j < directChildren[i].children.length; j++) {
                    const el = directChildren[i].children[j]
                    const { tagName } = el
                    const isHeading = headings.includes(tagName)

                    if (!isHeading) {
                        tmpArr.push(el)
                    } else {
                        if (tmpArr.length) splitByHeading.push(tmpArr)
                        tmpArr = [el]
                    }
                    if (j === directChildren[i].children.length - 1) {
                        splitByHeading.push(tmpArr)
                    }
                    console.log('splitByHeadingsplitByHeadingsplitByHeading', splitByHeading)
                }
            }
        }

        for (const arrOfEls of splitByHeading) {
            if (!arrOfEls.find((x) => x.tagName === 'DETAILS' && x.style.display !== 'none')) {
                for (const el of arrOfEls) {
                    hideElement(el)
                }
            } else {
                for (const el of arrOfEls) {
                    if (el.tagName !== 'DETAILS') {
                        showElement(el)
                    }
                }
            }
        }
    } catch (err) {
        console.log('error while working with html elements')
    }
}

/**
 *
 */
const TabMarkdown = (props) => {
    const classes = useStyles()

    return (
        <Grid container spacing={4}>
            <Grid item xs={12} md={8} lg={6} className={classes.searchContainer}>
                {props.searchable && <TextField leadingIcon='search' placeholder='Type your question here...' className='search-input' onChange={searchDetails} />}
            </Grid>
            <Grid item xs={12} className={`${classes.topContainer} ${containerClass}`}>
                <PDCMarkdown styleOverrides={props.styleOverrides}>
                    {props.children}
                </PDCMarkdown>
            </Grid>
        </Grid>
    )
}

export default TabMarkdown
